import React from 'react';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

interface OfferExpandNudgeProps {
  /** The full list's size (the same count the Full have/want list toggle shows). */
  count: number;
  onExpand: () => void;
}

/**
 * The dashed nudge under the compact panel's search box once the full list is
 * larger than the auto-focus threshold (Asana 1219788320590626 Decision 9).
 * Clicking it is a manual Expand: it focuses the side but never folds the nav
 * (Decision 11 scopes the nav fold to the automatic path).
 */
export const OfferExpandNudge: React.FC<OfferExpandNudgeProps> = ({ count, onExpand }) => (
  <button
    type="button"
    className="offer-expand-nudge"
    onClick={onExpand}
    data-testid="offer-expand-nudge"
  >
    <OpenInFullIcon fontSize="inherit" aria-hidden="true" />
    <span>
      {count.toLocaleString()} cards. Expand to browse them in a grid, with filters.
    </span>
  </button>
);

export default OfferExpandNudge;
